exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vc-popup-base{\n  width: 100%;\n  height: 100%;\n  top: 0;\n}\n.vc-popup-slot{\n  position: relative;\n  z-index: 0;\n  height: 0;\n}\n.vc-popup-default-transition {\n  -webkit-transition: all 280ms ease;\n  transition: all 280ms ease;\n}\n.vc-popup-mask {\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  background-color: #000000;\n  -webkit-transition: opacity 350ms ease 0s;\n  transition: opacity 350ms ease 0s;\n  /* will-change: opacity; */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76ca6e5c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup-base/popup-base.vue
// module id = 47
// module chunks = 1